import { render, staticRenderFns } from "./QueueModal.vue?vue&type=template&id=becf4248&scoped=true"
import script from "./QueueModal.vue?vue&type=script&lang=js"
export * from "./QueueModal.vue?vue&type=script&lang=js"
import style0 from "./QueueModal.vue?vue&type=style&index=0&id=becf4248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "becf4248",
  null
  
)

export default component.exports